// ============================================================================
// RECSUIT MODULE + ACTION CODES (web-side mirror)
// ============================================================================
// Mirrors recsuit-api/src/recsuit.Core/Constants/RecsuitModuleCodes.cs.
// Both files MUST stay in sync — strings are the contract between
// server-side [HasPermission(module, action)] and client-side
// <PermissionGate module=… action=…>.

export const RecsuitModuleCodes = {
  // Master Data
  Zone: 'zone-master',
  Region: 'region-master',
  Area: 'area-master',
  Branch: 'branch-master',

  // Catalogs (Phase 2)
  Product: 'product-master-catalog',
  ActionType: 'action-type-master',
  ClosureReason: 'closure-reason-master',
  ProceedingType: 'proceeding-type-master',
  NoticeType: 'notice-type-master',
  NoticeReturnStatus: 'notice-return-status-master',
  ExpenseType: 'expense-type-master',
  CourtPlace: 'court-place-master',
  Court: 'court-master',
  CourtType: 'court-type-master',
  Arbitrator: 'arbitrator-master',
  Advocate: 'advocate-master',
  NoticeTemplate: 'notice-template-master',

  // Configuration (Phase 3)
  ConfigSettings: 'config-settings',
  CaseNumberFormat: 'case-number-format-master',

  // Administration (Phase 4)
  Role: 'role-master',

  // Workflow Framework (Phase 6c)
  WorkflowDefinitions: 'workflow-definitions',
  ApprovalInbox: 'approval-inbox',

  // Pre-Litigation (Phase 7)
  PreLitigationPool: 'pre-litigation-pool',
  PreLitigationCase: 'pre-litigation-case',
  AccountCases:      'account-cases',

  // Litigation (Phase 9)
  LitigationCase:    'litigation-case',

  // Recovery Officer Dashboard (Phase 8.D)
  RecoveryDashboard: 'recovery-dashboard',

  // Eligibility Criteria Master (Phase E)
  EligibilityCriteria: 'eligibility-criteria',

  // Case Group / Batch Proceedings (Phase A) — auction, Adalath, OTS, conciliation,
  // settlement drive, Lok Adalat (group_type discriminates inside).
  CaseGroup: 'case-group',
} as const;

export type RecsuitModuleCode =
  typeof RecsuitModuleCodes[keyof typeof RecsuitModuleCodes];

export const RecsuitActionCodes = {
  Add: 'add',
  Edit: 'edit',
  Delete: 'delete',
  View: 'view',
  Export: 'export',

  // Pre-Litigation (Phase 7)
  Claim:             'claim',
  Assign:            'assign',
  LogAction:         'log_action',
  CaptureCommitment: 'capture_commitment',
  ResolveCommitment: 'resolve_commitment',
  Escalate:          'escalate',
  ManualClose:       'manual_close',
  RecomputePool:     'recompute_pool',

  // Litigation case-level (Phase 7 — close/hold rework)
  Close:             'close',
  Reopen:            'reopen',
  Hold:              'hold',
  Resume:            'resume',
} as const;

/** PRIMA-style scope codes — encoded as action codes in module_actions JSONB. */
export const RecsuitScopeCodes = {
  ViewOwn:       'view-own',
  ViewOwnTeam:   'view-own-team',
  ViewAll:       'view-all',
  ManageOwn:     'manage-own',
  ManageOwnTeam: 'manage-own-team',
  ManageAll:     'manage-all',
} as const;

export type RecsuitActionCode =
  typeof RecsuitActionCodes[keyof typeof RecsuitActionCodes];
